import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { BookingsAvailability } from "@/api/types";
import { getBookingsAvailability } from "@/api/bookings";
import store from "@/store";

export interface BookingsState {
  bookingsAvailability: BookingsAvailability;
}

@Module({ dynamic: true, store, name: "bookings" })
class Bookings extends VuexModule implements BookingsState {
  public bookingsAvailability: BookingsAvailability = {};

  @Action({ rawError: true })
  public async getBookingsAvailability(opts: {
    shopId: string;
    serviceId: string;
    resourceId: string;
    storeAgg: any;
  }) {
    let availableBookingTimes: BookingsAvailability;
    if (opts.resourceId === "Any") {
      const { services } = opts.storeAgg;
      const service = services[opts.serviceId];
      const resources = service.resources;
      const arr = [];
      for (const resource of resources) {
        const singleBookings = await getBookingsAvailability(resource, opts.serviceId);
        if (singleBookings) {
          arr.push(singleBookings);
        }
      }
      availableBookingTimes = arr.reduce((a, b) => {
        for (const date in b) {
          if (date in a ) {
            a[date] = Array.from(new Set([...b[date], ...a[date]])).sort();
          } else {
            a[date] = b[date];
          }
        }
        return a;
      });
    } else {
      availableBookingTimes = await getBookingsAvailability(opts.resourceId, opts.serviceId);
    }

    const sortedAvailableBookingTimes: BookingsAvailability = {};
    Object.keys(availableBookingTimes).sort().forEach(function(key) {
        sortedAvailableBookingTimes[key] = availableBookingTimes[key];
      });
    this.SET_BOOKINGS_AVAILABILITY(sortedAvailableBookingTimes);
  }

  @Mutation
  private SET_BOOKINGS_AVAILABILITY(
    bookingsAvailability: BookingsAvailability
  ) {
    this.bookingsAvailability = bookingsAvailability;
  }
}

export const BookingsModule = getModule(Bookings);
